import { render, staticRenderFns } from "./OrganizationJobFamiliesTab.vue?vue&type=template&id=65114ec3&scoped=true"
import script from "./OrganizationJobFamiliesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationJobFamiliesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationJobFamiliesTab.vue?vue&type=style&index=0&id=65114ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65114ec3",
  null
  
)

export default component.exports